import { createContext, Dispatch, useContext } from "react"
import { IChatsUIAction, IChatsUIState, IChatUIInit } from "../ChatType"

interface IChatContextProps {
  state: IChatsUIState;
  dispatch: Dispatch<IChatsUIAction>;

  connect: (userId: string) => void;
  disconnect: () => void;
}

const ChatContext = createContext<IChatContextProps>({
  state: IChatUIInit,
  dispatch: (action: IChatsUIAction) => {return action},

  connect: () => {
    console.log("Connecting to chat server with userId")
  },
  disconnect: () => {
    console.log("Disconnecting from chat server")
  }
})

export const useChatContext = (): IChatContextProps => {
  return useContext(ChatContext)
}

export default ChatContext
